export default {
  init() {
    // JavaScript to be fired on all pages
    $('.featured-products').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
        {
          breakpoint: 995,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '150px',
          },
        },
        {
          // compare breakpoint to styling in featured-products-slider.scss
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            variableWidth: false,
            centerPadding: '80px',
          },
        },
        {
          // compare breakpoint to styling in featured-products-slider.scss
          breakpoint: 490,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // disable lazy loading
    $('.featured-products').slick("slickGoTo",1,true);
    $('.featured-products').slick("slickGoTo",0,true);

    const gallery_images = document.querySelectorAll('.product-gallery__image');

    function changeFocus(e){
        const focused = document.querySelectorAll('.focused');
        focused.forEach(focused_image => focused_image.classList.remove(`focused`));

        e.toElement.classList.add(`focused`);
    }

    gallery_images.forEach(gallery_image => gallery_image.addEventListener('click', changeFocus));
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js